import { Badge } from '@odin-labs/components';
import {
  SiteReaderKind,
  type SiteControllerReaderFieldsFragment,
} from 'apollo/generated/client-operations';
import moment from 'moment-timezone';
import React from 'react';

export type ReaderDisplayFields = Pick<
  SiteControllerReaderFieldsFragment,
  'kind' | 'entry' | 'health' | 'missing' | 'name'
>;

export const readerLabel = (
  reader: Pick<ReaderDisplayFields, 'kind' | 'entry' | 'name'>,
  controllerName?: string,
  portLabel?: string,
): string =>
  reader.kind === SiteReaderKind.Wiegand
    ? [controllerName, portLabel, reader.entry?.name ?? reader.name]
        .filter(Boolean)
        .join(', ')
    : reader.name;

export function ReaderKindBadge({
  kind,
}: {
  kind: SiteReaderKind;
}): React.ReactElement {
  return (
    <Badge
      text={kind === SiteReaderKind.Wiegand ? 'Wiegand' : 'Alta'}
      color="gray"
    />
  );
}

export function ReaderHealth({
  reader,
}: {
  reader: Pick<ReaderDisplayFields, 'kind' | 'health' | 'missing'>;
}): React.ReactElement {
  if (reader.kind === SiteReaderKind.Alta)
    return reader.missing ? (
      <Badge text="Missing" color="red" />
    ) : (
      <span>Present</span>
    );
  if (!reader.health.bound) return <span>Unbound in Alta</span>;
  return (
    <span>
      {reader.health.lastReadAt
        ? `Configured, last read ${moment(reader.health.lastReadAt).fromNow()}`
        : 'Configured, no reads yet'}
    </span>
  );
}
